import { render, staticRenderFns } from "./newHomeHeader1.vue?vue&type=template&id=7ffd0a7e&scoped=true&"
import script from "./newHomeHeader1.vue?vue&type=script&lang=js&"
export * from "./newHomeHeader1.vue?vue&type=script&lang=js&"
import style0 from "./newHomeHeader1.vue?vue&type=style&index=0&id=7ffd0a7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffd0a7e",
  null
  
)

export default component.exports